import { Component, OnInit, Output, EventEmitter, OnDestroy, Inject } from '@angular/core';
import { BaseComponent, PaymentDataService, AuthService } from '@ridango/core';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';
import { Platform } from '@ionic/angular';

@Component({
    selector: 'gl-wallet-loading-page-v2-choose-a-ticket',
    templateUrl: './choose-a-ticket.component.html',
    styleUrls: ['./choose-a-ticket.component.scss']
})
export class WalletLoadingPageV2ChooseATicketComponent extends BaseComponent implements OnInit, OnDestroy {
    @Output() backClicked = new EventEmitter<void>();
    @Output() nextClicked = new EventEmitter<void>();
    isNextDisabled = true;
    isCardFormValid = false;
    physicalBackButtonSubscription$: any;

    constructor(
        private paymentData: PaymentDataService,
        private authService: AuthService,
        @Inject('ENV') public env: Env,
        private platform: Platform
    ) {
        super();
    }

    ngOnInit(): void {
        this.checkValidity();
        combineLatest([this.paymentData.price$, this.paymentData.cardNumber$])
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => this.checkValidity());

        this.physicalBackButtonSubscription$ = this.platform.backButton.subscribeWithPriority(1000, () => {
            if (!this.env.PURCHASE_FLOW?.HIDE_WALLET_LOADING_BACK_BUTTON) {
                this.handleBackClicked();
            }
        });
    }

    ngOnDestroy(): void {
        if (this.physicalBackButtonSubscription$) {
            this.physicalBackButtonSubscription$.unsubscribe();
        }
        super.ngOnDestroy();
    }

    handleBackClicked(): void {
        this.backClicked.emit();
    }

    handleNextClicked(): void {
        this.nextClicked.emit();
    }

    checkValidity(): void {
        const price = this.paymentData.getProduct();
        const cardNumber = this.paymentData.getCard();
        const isLoggedIn = this.authService.getLoginStatus();

        if (isLoggedIn) {
            this.isNextDisabled = !price || !cardNumber;
        } else {
            this.isNextDisabled = !price || !cardNumber || !this.isCardFormValid;
        }
    }

    onCardFormValidityChange(isValid: boolean): void {
        this.isCardFormValid = isValid;
        this.checkValidity();
    }
}
